<template>
  <div class="socialSection">
                <div class="socialSection__follow">
                  <span> Follow us : </span>
                  <div class="socialSection__follow__links">
                    <a href="https://www.linkedin.com/company/mobilityintel/mycompany/?viewAsMember=true"> <img src="/static/cdn/linkedin_sv91t5.svg"> </a>
                    <a href="https://www.youtube.com/channel/UCNTzecJNHm7fYNzK64iS7Yg"> <img src="/static/cdn/youtube_wtyywa.svg"> </a>
                    <a href="https://twitter.com/MobilityIntel"> <img src="/static/cdn/twitter_iweegk.svg"> </a>
                    <a href="https://www.facebook.com/MobilityIntelGlobal"> <img src="/static/cdn/facebook_q5hcy0.svg"> </a>
                    <a href="https://www.instagram.com/mobilityintel/"> <img src="/static/cdn/insta_y3chtx.svg"> </a>


                  </div>
                </div>
                <div class="socialSection__block linkedin_posts">
                  <div class="socialSection__block__title">
                    LinkedIn Posts
                  </div>
                  <div class="socialSection__block__content">
                  <iframe src='https://www.sociablekit.com/app/embed/68977' frameborder='0' width='100%' height='1000'></iframe>
                  </div>  
                </div>
                <div class="socialSection__block facebook-feed">
                  <div class="socialSection__block__title">
                    Facebook Posts
                  </div>
                  <div class="socialSection__block__content">
                       <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FMobilityIntelGlobal&tabs=timeline&width=292&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="320" height="500" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
                    </div>  
                </div>
                
              </div>
</template>

<script>
export default {
  mounted(){
    $(document).ready(function(){
      var sidebar_width = $('.socialSection').width();
      // console.log('sidebar_width',sidebar_width);
      $(".facebook-feed iframe").attr('src','https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FMobilityIntelGlobal&tabs=timeline&width='+ sidebar_width +'&height=500&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId')

    });
  }
}
</script>

<style lang="scss">
.facebook-feed iframe{
    width: 100%;
    margin-top: 19px;
}
.socialSection{
  position: relative;
}
.socialSection__follow__links a{

 &:before {
    content: "";
    width: 0%;
    left: 50%;
    background-color: white;
    position: absolute;
    height: 3px;
    margin-top: 28px;
    transform: translate(-50%, -50%);
    transition:width 0.3s ease 0s;
}
  &:hover:before{
    width: 57%;
  }
}
.socialSection__block {
    border-top: 3px solid #24ad60;
    margin-top: 31px;
}
@media screen and (max-width:768px) {
    .linkedin_posts .socialSection__block__content {
      margin-left: -15px;
      margin-right: -21px;
  }
  .socialSection__follow{
    margin-top: 50px;
  }
}


</style>


// WEBPACK FOOTER //
// src/components/News/Parts/sidebare.vue